// extracted by mini-css-extract-plugin
module.exports = {"xs":"(max-width: 600px)","sm":"(max-width: 960px)","md":"(max-width: 1280px)","lg":"(max-width: 1920px)","xl":"(min-width: 1921px)"};